import cn from "classnames";
import { OnOptionSelect, SelectOption } from "../../../types/select.types";
import { InputProps } from "../Input";
import { SelectBody } from "./components/SelectBody";
import { SelectHeader } from "./components/SelectHeader";
import { SelectProvider } from "./context/SelectContext";
import styles from "./Select.module.scss";

export type SelectProps = Omit<InputProps, "onChange" | "readOnly" | "multiple"> & {
  selectValue?: SelectOption[];
  onChange?: OnOptionSelect;
  label?: string;
  multiple?: boolean;
  renderIcon?: JSX.Element;
  closeAfterSelection?: boolean;
  withCheckbox?: boolean;
  headerClassName?: string;
  selectLabelClassName?: string;
  bodyClassName?: string;
};

export const Select = ({
  children,
  onChange,
  label,
  closeAfterSelection = false,
  withCheckbox = false,
  bodyClassName,
  selectLabelClassName,
  ...inputProps
}: SelectProps) => {
  return (
    <div aria-label="select" className={styles.select}>
      <SelectProvider
        withCheckbox={withCheckbox}
        closeAfterSelection={closeAfterSelection}
        multiple={inputProps.multiple}
        initialValue={inputProps.selectValue}
        onSelectionChange={onChange}
      >
        {label && (
          <div aria-label="select-label" className={cn(styles.label, selectLabelClassName)}>
            {label}
          </div>
        )}
        <SelectHeader {...inputProps} />
        <SelectBody className={bodyClassName}>{children}</SelectBody>
      </SelectProvider>
    </div>
  );
};
